import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { companyActions } from "../slices/company";
import { getErrorMessage } from "../../utils/errorUtils";
import { CompanySetupRequestDto } from "../../shared/dtos/setup/CompanySetupRequestDto";
import { CompanyResponseDto } from "../../shared/dtos/company/CompanyResponseDto";
import { UpdateCompanyPayload } from "../../shared/interfaces/company/UpdateCompanyPayload";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const setupCompany =
  (payload: CompanySetupRequestDto, navigate?: Function) =>
  async (dispatch: AppDispatch) => {
    dispatch(companyActions.setLoadingCompanySetup());
    try {
      const { data } = await axiosInstance.post<
        ApiResponseDto<CompanyResponseDto>
      >("/public/setup-company", payload, { headers: { requiresAuth: false } });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        toast.success(data.message || "Company registered successfully!");
        localStorage.setItem("companyInfo", JSON.stringify(data.data));
        dispatch(companyActions.setCompany(data.data));
        if (navigate) navigate("/login");
      }
    } catch (error) {
      dispatch(companyActions.setErrorSetupCompany(getErrorMessage(error)));
    }
  };

export const getCompany =
  () =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(companyActions.setLoadingCompany());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<CompanyResponseDto>
      >("/company", { headers: { requiresAuth: true } });
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        localStorage.setItem("companyInfo", JSON.stringify(data.data));
        dispatch(companyActions.setCompany(data.data));
      }
    } catch (error) {
      dispatch(companyActions.setErrorLoadingCompany(getErrorMessage(error)));
    }
  };

export const updateCompany =
  (payload: UpdateCompanyPayload) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(companyActions.setLoadingCompanyUpdate());
    try {
      const { data } = await axiosInstance.put<
        ApiResponseDto<CompanyResponseDto>
      >(`/company/${payload.id}`, payload.values, {
        headers: { requiresAuth: true },
      });
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        toast.success(data.message || "Company details updated!");
        localStorage.setItem("companyInfo", JSON.stringify(data.data));
        dispatch(companyActions.updateCompanySuccess(data.data));
        dispatch(
          companyActions.setServerResponseStatus(data.statusCode || 200),
        );
      }
    } catch (error) {
      dispatch(companyActions.setErrorUpdatingCompany(getErrorMessage(error)));
    }
  };

export const resetCompanyServerStatus = () => (dispatch: AppDispatch) => {
  dispatch(companyActions.setServerResponseStatus(null));
};
